import React, { useState } from "react";
import { Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane, faTimes } from "@fortawesome/free-solid-svg-icons";
import "../../../molecules/BrandModal.css";

export const SendBackToVendorModal = ({
  toggle,
  setToggle,
  onSendBackToVendor,
  account,
}) => {
  const [additional, setAdditional] = useState("");
  const [showAdditionalError, setShowAdditionalError] = useState(false);

  const close = () => {
    setToggle(false);
    setAdditional("");
    setShowAdditionalError(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!additional.trim()) {
      setShowAdditionalError(true);
      return;
    }

    close();
    onSendBackToVendor(account.id, additional);
  };

  return (
    <Modal isOpen={toggle} toggle={close} className="brand-modal">
      <ModalHeader toggle={close}>Send Back to Vendor</ModalHeader>
      <ModalBody>
        <p className="brand-modal__desc">Please provide a justification for sending this account back to the vendor.</p>
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label for="sendBackReason">Justification</Label>
            <Input
              type="textarea"
              id="sendBackReason"
              placeholder="Justification text that will be included in email"
              value={additional}
              onChange={(e) => {
                setAdditional(e.target.value);
                if (e.target.value.trim()) setShowAdditionalError(false);
              }}
            />
            {showAdditionalError && <p className="text-danger">Required</p>}
          </FormGroup>

          <div className="brand-modal__actions">
            <button type="submit" className="brand-modal__btn brand-modal__btn--primary">
              <FontAwesomeIcon icon={faPaperPlane} /> Send Back
            </button>
            <button type="button" className="brand-modal__btn brand-modal__btn--cancel" onClick={close}>
              <FontAwesomeIcon icon={faTimes} /> Close
            </button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};
